module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "portlet box blue-hoki"
  }, [_vm._m(0, false, false), _vm._v(" "), _c('div', {
    staticClass: "portlet-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 center"
  }, [_c('el-date-picker', {
    attrs: {
      "editable": false,
      "type": "date",
      "format": "yyyy-MM-dd",
      "value-format": "yyyy-MM-dd",
      "clearable": false,
      "placeholder": "From"
    },
    on: {
      "change": function($event) {
        _vm.dateFromSelected()
      }
    },
    model: {
      value: (_vm.from_date),
      callback: function($$v) {
        _vm.from_date = $$v
      },
      expression: "from_date"
    }
  }), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "type": "date",
      "format": "yyyy-MM-dd",
      "value-format": "yyyy-MM-dd",
      "clearable": false,
      "placeholder": "To"
    },
    on: {
      "change": function($event) {
        _vm.dateToSelected()
      }
    },
    model: {
      value: (_vm.to_date),
      callback: function($$v) {
        _vm.to_date = $$v
      },
      expression: "to_date"
    }
  })], 1)]), _vm._v(" "), _vm._m(1, false, false)])])])]), _vm._v(" "), _vm._m(2, false, false), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "portlet box blue-hoki"
  }, [_vm._m(3, false, false), _vm._v(" "), _c('div', {
    staticClass: "portlet-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 center"
  }, [_c('el-date-picker', {
    attrs: {
      "editable": false,
      "type": "date",
      "format": "yyyy-MM-dd",
      "value-format": "yyyy-MM-dd",
      "clearable": false,
      "placeholder": "From"
    },
    on: {
      "change": function($event) {
        _vm.orderCountDateFromSelected()
      }
    },
    model: {
      value: (_vm.order_count_from_date),
      callback: function($$v) {
        _vm.order_count_from_date = $$v
      },
      expression: "order_count_from_date"
    }
  }), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "type": "date",
      "format": "yyyy-MM-dd",
      "value-format": "yyyy-MM-dd",
      "clearable": false,
      "placeholder": "To"
    },
    on: {
      "change": function($event) {
        _vm.orderCountDateToSelected()
      }
    },
    model: {
      value: (_vm.order_count_to_date),
      callback: function($$v) {
        _vm.order_count_to_date = $$v
      },
      expression: "order_count_to_date"
    }
  })], 1)]), _vm._v(" "), _vm._m(4, false, false)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "portlet-title bg-blue-chambray"
  }, [_c('div', {
    staticClass: "caption",
    staticStyle: {
      "font-size": "14px"
    }
  }, [_c('span', {
    staticClass: "fa-stack fa-sm"
  }, [_c('i', {
    staticClass: "fa fa-circle fa-stack-2x",
    staticStyle: {
      "color": "rgb(26,188,156)",
      "line-height": "inherit"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-user fa-stack-1x",
    staticStyle: {
      "color": "rgb(255,255,255)",
      "line-height": "inherit"
    },
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v("\n\t\t\t\t\t\tNew User Registrations by Month\n\t\t\t\t\t")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticStyle: {
      "height": "350px"
    },
    attrs: {
      "id": "chart_div"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "portlet box blue-hoki"
  }, [_c('div', {
    staticClass: "portlet-title bg-blue-chambray"
  }, [_c('div', {
    staticClass: "caption",
    staticStyle: {
      "font-size": "14px"
    }
  }, [_c('span', {
    staticClass: "fa-stack fa-sm"
  }, [_c('i', {
    staticClass: "fa fa-circle fa-stack-2x",
    staticStyle: {
      "color": "#e67e22",
      "line-height": "inherit"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-user fa-stack-1x",
    staticStyle: {
      "color": "rgb(255,255,255)",
      "line-height": "inherit"
    },
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v("\n\t\t\t\t\t\tUsers by Platform\n\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "portlet-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticStyle: {
      "height": "350px"
    },
    attrs: {
      "id": "chart_div_usersByPlatform"
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "portlet box blue-hoki"
  }, [_c('div', {
    staticClass: "portlet-title bg-blue-chambray"
  }, [_c('div', {
    staticClass: "caption",
    staticStyle: {
      "font-size": "14px"
    }
  }, [_c('span', {
    staticClass: "fa-stack fa-sm"
  }, [_c('i', {
    staticClass: "fa fa-circle fa-stack-2x",
    staticStyle: {
      "color": "#9b59b6",
      "line-height": "inherit"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-user fa-stack-1x",
    staticStyle: {
      "color": "rgb(255,255,255)",
      "line-height": "inherit"
    },
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v("\n\t\t\t\t\t\tActive Users\n\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "portlet-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticStyle: {
      "height": "350px"
    },
    attrs: {
      "id": "chart_div_activeUsers"
    }
  })])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "portlet-title bg-blue-chambray"
  }, [_c('div', {
    staticClass: "caption",
    staticStyle: {
      "font-size": "14px"
    }
  }, [_c('span', {
    staticClass: "fa-stack fa-sm"
  }, [_c('i', {
    staticClass: "fa fa-circle fa-stack-2x",
    staticStyle: {
      "color": "#e67e22",
      "line-height": "inherit"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-user fa-stack-1x",
    staticStyle: {
      "color": "rgb(255,255,255)",
      "line-height": "inherit"
    },
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v("\n\t\t\t\t\t\tUsers by Order Count\n\t\t\t\t\t")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticStyle: {
      "height": "350px"
    },
    attrs: {
      "id": "chart_div_usersByOrderCount"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4c37537c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/app/Analytics/UserAnalytics.vue
// module id = 713
// module chunks = 0